// return a percentage for the strength of a password [0 - 100]

const getPasswordStrengthPercentage = (password: any) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSymbol = /[^\w\s]/.test(password);
  const hasMinChars = password?.length >= 8;

  if (!password) return 0;

  // other rules shouldn't matter if the password is less then or equal 4
  if (password.length <= 4) return 0;

  return (
    [hasUpperCase, hasNumber, hasSymbol, hasLowerCase, hasMinChars].filter(Boolean).length * 20
  );
};

export { getPasswordStrengthPercentage };
